export const parseBool = (b) => (b ? "Yes" : "No")
